import React from 'react';

import './ImageBanner.scss';
import images from '../../shared/assets/images';

const { baby } = images;

export default function ImageBanner() {
  return (
    <section id="imageBanner">
      <img alt="baby-image" src={baby} />
    </section>
  );
}
